import { render, staticRenderFns } from "./model_list.vue?vue&type=template&id=16f37d9b&scoped=true"
import script from "./model_list.vue?vue&type=script&lang=ts"
export * from "./model_list.vue?vue&type=script&lang=ts"
import style0 from "./model_list.vue?vue&type=style&index=0&id=16f37d9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f37d9b",
  null
  
)

export default component.exports